if (!customElements.get('t4-hero')) {
  customElements.define(
    't4-hero',
    class T4Hero extends HTMLElement {
      // Exposes the hero's distance from the top of the page (announcement bar + header)
      // so CSS can size it to exactly fill the first viewport.
      connectedCallback() {
        this.update = this.update.bind(this);
        this.update();
        window.addEventListener('resize', this.update, { passive: true });
        window.addEventListener('load', this.update, { once: true });

        const header = document.querySelector('.shopify-section-group-header-group');
        if (header && 'ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.update);
          this.observer.observe(header);
        }
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
        this.observer?.disconnect();
      }

      update() {
        const offset = Math.max(0, Math.round(this.getBoundingClientRect().top + window.scrollY));
        this.style.setProperty('--hero-offset', `${offset}px`);
      }
    }
  );
}
